import { gql } from '@apollo/client';

export const GET_PROPOSALS = gql`
  query Proposals(
    $name: String
    $influencers: [influencerFilter]
    $client: [influencerFilter]
    $status: String
    $offset: Int
    $limit: Int
  ) {
    proposals(
      name: $name
      influencers: $influencers
      client: $client
      status: $status
      offset: $offset
      limit: $limit
    ) {
      status
      code
      error
      count
      data {
        id
        name
        status
        campaign_type
        money
        currency
        month
        ProposalUsers {
          id
          profile_picture
          status
          name
          total_amount
          exclusivity
        }
      }
    }
  }
`;

export const GET_PROPOSAL = gql`
  query Proposal($proposalId: ID!) {
    proposal(proposalId: $proposalId) {
      status
      code
      error
      data {
        id
        name
        status
        campaign_type
        brand_id
        brand_name
        brand_profile_picture
        money
        currency
        month
        from_date
        to_date
        campaign_id
        contract_url
        logo_url
        pdf_url
        drive_url
        drive_document_id
        drive_document_url
        group_id
        accountManagers {
          id
          name
          profile_picture
        }
        missing_from_ppt
        signedDocument {
          id
          document_id
          signed_at
          proposal_id
        }
        ProposalUsers {
          id
          user_id
          total_amount
          influencer_amount
          influencer_amount_type
          total_variable_amount
          influencer_variable_amount
          influencer_variable_type
          initDate
          finishDate
          status
          accepted_at
          rejected_at
          selected_pack_id
          name
          profile_picture
          actions {
            id
            proposal_user_id
            type
            platform
            description
            hasScript
            hasPreview
            internal_validation
            number_of_action
            variable_type
            total_amount
            total_currency
            influencer_amount
            influencer_currency
          }
          packs {
            id
            proposal_user_id
            name
            position
            total_amount
            influencer_amount
            actions {
              id
              proposal_user_id
              pack_id
              type
              platform
              description
              hasScript
              hasPreview
              internal_validation
              number_of_action
              month
              variable_type
              total_amount
              total_currency
              influencer_amount
              influencer_currency
            }
          }
        }
      }
    }
  }
`;
